import { c as __assign } from '../../../tslib.es6-80f01feb.js';
import { makeObservable, observable, action } from 'mobx';
import { environmentBuilder } from '../helpers/environmentBuilder.js';
import '../../../moment-27179cac.js';
import '../enums/GameSpecificTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/RequestStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';
import '../../../_commonjsHelpers-4c2b67c2.js';

var bannerImageTypeList = ['jpg', 'png', 'gif', 'svg'];
var LobbyStore = /** @class */ (function () {
    function LobbyStore() {
        this.gameTypes = [];
        this.hasDemo = true;
        this.roomName = '';
        this.lobbyDurationsByGameTypeId = {};
        this.sliderBanners = [];
        makeObservable(this, {
            lobbyDurationsByGameTypeId: observable.deep,
            roomName: observable.deep,
            gameTypes: observable.deep,
            hasDemo: observable.deep,
            sliderBanners: observable.deep,
            setLobbyDurationsByGameTypeId: action.bound,
            setGameTypes: action.bound,
            setHasDemo: action.bound,
            setRoomName: action.bound,
            setSliderBanners: action.bound,
        });
    }
    LobbyStore.prototype.setLobbyDurationsByGameTypeId = function (arg) {
        this.lobbyDurationsByGameTypeId = arg;
    };
    LobbyStore.prototype.setGameTypes = function (gameTypes) {
        this.gameTypes = gameTypes;
    };
    LobbyStore.prototype.setHasDemo = function (hasDemo) {
        this.hasDemo = hasDemo;
    };
    LobbyStore.prototype.setRoomName = function (name) {
        this.roomName = name;
    };
    LobbyStore.prototype.setSliderBanners = function (banners) {
        var httpBannersUrl = environmentBuilder().httpBannersUrl;
        this.sliderBanners = banners
            .sort(function (a, b) { return a.priority - b.priority; })
            .map(function (banner, index) {
            var _a;
            var bannerType = (_a = banner === null || banner === void 0 ? void 0 : banner.url) === null || _a === void 0 ? void 0 : _a.split('.').pop();
            var isVideo = banner.isVideo || !bannerImageTypeList.includes(bannerType);
            return __assign(__assign({}, banner), { url: "".concat(httpBannersUrl, "/").concat(banner.url), id: index + 1, isVideo: isVideo, isActive: !index, isPrev: false });
        });
    };
    return LobbyStore;
}());
var lobbyStore = new LobbyStore();

export { LobbyStore, lobbyStore };
